import { getV1CompaniesCompanyIdSiteIdStats } from '@treadinc/horizon-api-spec';
import { isAxiosError } from 'axios';
import { t } from 'i18next';
import { useState } from 'react';

import connection from '~services/connectionModule';

import { SiteEquipmentStats } from './models';

export const useSiteEquipmentStats = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getSiteEquipmentStats = async ({
    companyId,
    siteId,
  }: {
    companyId: string;
    siteId: string;
  }) => {
    setIsLoading(true);

    try {
      const response = await getV1CompaniesCompanyIdSiteIdStats({
        path: { 'company-id': companyId, 'site-id': siteId },
      });
      const parsedStats = SiteEquipmentStats.parse(response.data.data);

      return parsedStats;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return null;
      }

      connection.handleRequestError(error, t('error_messages.sites.failed_to_fetch'));
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, getSiteEquipmentStats };
};
